/**
 * @file Drag source tasks base component
 * @author Heino Lenting
 */
import * as tslib_1 from "tslib";
import { DragSourceBaseComponent } from '../drag-source-base/drag-source-base.component';
/** Drag source tasks base component */
var DragSourceTasksBaseComponent = /** @class */ (function (_super) {
    tslib_1.__extends(DragSourceTasksBaseComponent, _super);
    function DragSourceTasksBaseComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * Keep track of the setting 'norm'.
         * @private
         */
        _this._norm = true;
        return _this;
    }
    /**
     * Initiate the executors for given source
     */
    DragSourceTasksBaseComponent.prototype.initiateExecutors = function () {
        // Get the executors
        this.availableExecutors = this.executorsService.getExecutors('drop', 'Task');
        // We want task-drop-prognosed to be first in the list #3956
        var index = this.availableExecutors.findIndex(function (x) { return x.name === 'task-drop-prognosed'; });
        if (index > -1) {
            var firstExecutor = this.availableExecutors.splice(index, 1)[0];
            this.availableExecutors.unshift(firstExecutor);
        }
        // Default pick the first available drop method
        this.selectedExecutorName = (this.availableExecutors.length > 0) ? this.availableExecutors[0].name : undefined;
    };
    /**
     * Filters out tasks that are already fully planned
     * @protected
     * @param {Entity} item The task
     * @returns A value indicating whether the task should be included
     */
    DragSourceTasksBaseComponent.prototype.itemFilter = function (item) {
        // Issue: Mechanisme van zichtbaarheid en onzichtbaarheid van een projecttaak in de dragsources #2828
        // Op I-Dag van 30 augustus 2019 hebben we besloten verlopig hierop niet te filteren.
        // Oude code:
        // return !(<Task>item).isFullyPlanned();
        return true;
    };
    /**
    * Gets the format by the filtername
    * @param {string} filter the filtername
    * @type {EntityFormat}
    * @memberOf PlanboardGridBarComponent
    */
    DragSourceTasksBaseComponent.prototype.getFilterFormat = function (filter) {
        return this.gridService.getFormat(filter);
    };
    Object.defineProperty(DragSourceTasksBaseComponent.prototype, "norm", {
        /**
         * Gets the norm property.
         * @type {boolean}
         */
        get: function () {
            return this._norm;
        },
        /**
         * Sets the norm property.
         */
        set: function (value) {
            if (this._norm === value) {
                return;
            }
            this._norm = value;
            this.refresh();
        },
        enumerable: true,
        configurable: true
    });
    return DragSourceTasksBaseComponent;
}(DragSourceBaseComponent));
export { DragSourceTasksBaseComponent };
